import type { CliE2eeRuntime } from '../../lib/e2ee/index.js';
import type { SessionWorktreeManager } from '../../worktrees/manager.js';
import { generateShortcutToken } from './generate-token.js';
import { startLocalShortcutServer } from './start-server.js';
import type { LocalShortcutIdentifyFields, LocalShortcutServerHandle } from './types.js';

export type LocalShortcutCreateParams = {
  workspaceId: string;
  sessionWorktreeManager: SessionWorktreeManager;
  e2ee?: CliE2eeRuntime;
};

export type LocalShortcutCreateResult = {
  handle: LocalShortcutServerHandle;
  identify: LocalShortcutIdentifyFields;
};

export async function createLocalShortcut(params: LocalShortcutCreateParams): Promise<LocalShortcutCreateResult> {
  const token = generateShortcutToken();
  const handle = await startLocalShortcutServer({
    workspaceId: params.workspaceId,
    token,
    sessionWorktreeManager: params.sessionWorktreeManager,
    e2ee: params.e2ee,
  });
  return {
    handle,
    identify: {
      localShortcutPort: handle.port,
      localShortcutToken: handle.token,
    },
  };
}
